import { useTexts } from '@/feature/lang';
import { Icon } from '@/icon/Icon';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import { Flex } from '../../Flex';
import Translate from '../../Translate';
import { useDataProvider } from '../DataProviderContext';

export const useIsPaginationVisible = () => {
  const { table, getRowCount } = useDataProvider();
  const hasRows = getRowCount() > 0;

  return typeof table?.options.getPaginationRowModel === 'function' && hasRows;
};

function usePaginationInfo() {
  const { table, getRowCount } = useDataProvider();
  const rowCount = getRowCount();

  if (table === undefined || rowCount === undefined) {
    return undefined;
  }

  const { pageIndex, pageSize } = table.getState().pagination;
  const from = pageIndex * pageSize + 1;
  const to = Math.min(rowCount, from + pageSize - 1);

  return { from, to, count: rowCount };
}

export const Pagination = () => {
  const { table } = useDataProvider();
  const isVisible = useIsPaginationVisible();
  const info = usePaginationInfo();
  const texts = useTexts().component.dataGrid;

  if (!table || !isVisible || !info) {
    return null;
  }

  return (
    <Flex gap={1}>
      <IconButton
        onClick={table.previousPage}
        disabled={!table.getCanPreviousPage()}
      >
        <Icon name="chevron_left" size="small" />
      </IconButton>
      <Typography variant="body2" sx={{ whiteSpace: 'nowrap' }}>
        <Translate text={texts.displayedRows} values={info} />
      </Typography>
      <IconButton onClick={table.nextPage} disabled={!table.getCanNextPage()}>
        <Icon name="chevron_right" size="small" />
      </IconButton>
    </Flex>
  );
};
